var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.001,
    height: 16.667,
    viewBox: "0 0 15.001 16.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-staff",
    transform: "translate(0.833 0.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16.667,17.5V15.833A3.334,3.334,0,0,0,13.333,12.5H6.667a3.334,3.334,0,0,0-3.334,3.333V17.5",
    transform: "translate(-3.333 -2.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Path-2",
    "data-name": "Path",
    cx: 3.333,
    cy: 3.333,
    r: 3.333,
    transform: "translate(3.334)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStaff);
export default __webpack_public_path__ + "static/media/icon-staff.bd7212e01ecfebf2ebdb72b37ff1ac4d.svg";
export { ForwardRef as ReactComponent };